import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import Translator from "@/components/platform/Translator";
import FacultyRegistry from "@/components/platform/FacultyRegistry";
import KnowledgeHub from "@/components/platform/KnowledgeHub";
import EngineDashboard from "@/components/platform/EngineDashboard";
import PredictiveRadar from "@/components/platform/PredictiveRadar";

const MODULES = [
  { value: "dashboard", label: "Engine Dashboard", color: "#0077B6", code: "01" },
  { value: "translator", label: "Demand → Programme", color: "#D95D39", code: "02" },
  { value: "registry",  label: "Faculty Registry",   color: "#4C956C", code: "03" },
  { value: "hub",       label: "Knowledge Hub",      color: "#4C956C", code: "04" },
  { value: "radar",     label: "Predictive Radar",   color: "#D95D39", code: "05" },
];

export default function Platform() {
  const [tab, setTab] = useState("dashboard");
  return (
    <main data-testid="platform-page" className="min-h-screen bg-navy text-cream dark-section">
      <div className="bg-lattice-dark">
        <div className="max-w-[1500px] mx-auto px-6 lg:px-10 pt-28 pb-10">
          <div className="font-mono-data text-xs tracking-[0.3em] uppercase text-[#E8B298] mb-3">UNNATI Working Layer</div>
          <h1 className="font-serif-display text-4xl lg:text-5xl leading-tight max-w-4xl">
            The platform. <span className="italic text-[#E8B298]">Live, inspectable, interactive.</span>
          </h1>
          <p className="mt-4 max-w-2xl text-cream/70 text-[15px]">
            Five modules — wired into one continuous engine. Switch between them to see how demand, delivery and knowledge
            move through the system.
          </p>
        </div>
      </div>

      <Tabs value={tab} onValueChange={setTab} className="w-full">
        <div className="sticky top-16 z-30 bg-navy/90 backdrop-blur-xl border-y border-white/10">
          <div className="max-w-[1500px] mx-auto px-6 lg:px-10 overflow-x-auto">
            <TabsList data-testid="platform-tabs" className="bg-transparent h-auto p-0 gap-2">
              {MODULES.map(m => (
                <TabsTrigger key={m.value} value={m.value} data-testid={`tab-${m.value}`}
                  className="group data-[state=active]:bg-transparent data-[state=active]:text-cream rounded-none
                             border-b-2 border-transparent data-[state=active]:border-[color:var(--t)] px-4 py-4 text-cream/60 data-[state=active]:text-cream
                             font-mono-data text-xs tracking-[0.18em] uppercase whitespace-nowrap"
                  style={{"--t": m.color}}>
                  <span className="opacity-50 mr-2">{m.code}</span>{m.label}
                </TabsTrigger>
              ))}
            </TabsList>
          </div>
        </div>

        <div className="max-w-[1500px] mx-auto px-6 lg:px-10 py-10">
          <TabsContent value="dashboard"><EngineDashboard /></TabsContent>
          <TabsContent value="translator"><Translator /></TabsContent>
          <TabsContent value="registry"><FacultyRegistry /></TabsContent>
          <TabsContent value="hub"><KnowledgeHub /></TabsContent>
          <TabsContent value="radar"><PredictiveRadar /></TabsContent>
        </div>
      </Tabs>
    </main>
  );
}
